import type { ImgHTMLAttributes } from "react"

import logoDarkSrc from "@/assets/logo/logo-dark.png"
import logoLightSrc from "@/assets/logo/logo-light.png"
import { cn } from "@/lib/utils"

export default function AppLogoIcon({
  className,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) {
  return (
    <>
      <img
        src={logoLightSrc}
        alt="Broadside"
        className={cn("dark:hidden", className)}
        {...props}
      />
      <img
        src={logoDarkSrc}
        alt="Broadside"
        className={cn("hidden dark:block", className)}
        {...props}
        aria-hidden="true"
      />
    </>
  )
}
